import {useController, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {useEffect, useState} from "react";
import type {FocusEvent} from "react";
import {ProductGenInfoFormFieldsType} from "../types";
import {ProductGenInfoNameFormFieldProps} from "./types";
import {FormField, FormFieldError} from "../../../../../design-system/form-field";

export function ProductGenInfoNameFormField({
  id,
  label,
  placeholder,
}: ProductGenInfoNameFormFieldProps) {
  const {control} = useFormContext<ProductGenInfoFormFieldsType>();

  const {field, fieldState} = useController({
    name: "name",
    control,
  });
  const fieldValue = field.value as string | undefined;

  const [nameValue, setNameValue] = useState<string | undefined>(fieldValue);

  useEffect(() => {
    setNameValue(fieldValue);
  }, [fieldValue]);

  function handleBlur(e: FocusEvent<HTMLInputElement, Element>) {
    field.onChange(e);
    field.onBlur();
  }

  function handleChange(e: FocusEvent<HTMLInputElement, Element>) {
    setNameValue(e.target.value);
  }

  return (
    <div>
      <FormField
        id={id}
        label={label}
        renderInput={(id) => (
          <Space direction="vertical" size={16} style={{display: "flex"}}>
            <Input
              id={id}
              status={fieldState.error?.message ? "error" : ""}
              value={nameValue}
              onChange={handleChange}
              onBlur={handleBlur}
              size="large"
              placeholder={placeholder}
              ref={field.ref}
            />
            <FormFieldError errorMessage={fieldState.error?.message} />
          </Space>
        )}
      />
    </div>
  );
}
